import { useState, useCallback } from 'react'

const DEFAULT_SETTINGS = {
  objectType:         '',
  summaryAttribute:   '',
  taskLabelAttribute: '',
  taskStartActivity:  [],
  taskEndActivity:    [],
  durationUnit:       'h',
  startFallback:      'hide',
  endFallback:        'hide',
  endFallbackDays:    7,
  summaryPlannedStart: '',
  summaryPlannedEnd:   '',
  taskPlannedStart:    '',
  taskPlannedEnd:      '',
  summaryExtraColumns: [],
  taskExtraColumns:    [],
  taskTooltipAttributes: [],
  markerActivities:    [],
}

export function useGanttSettings(initialSettings) {
  const [settings, setSettings] = useState(() =>
    initialSettings ? { ...DEFAULT_SETTINGS, ...initialSettings } : DEFAULT_SETTINGS
  )

  const updateSetting = useCallback((key, value) =>
    setSettings(prev => ({ ...prev, [key]: value })), [])

  const updateSettings = useCallback((updates) =>
    setSettings(prev => ({ ...prev, ...updates })), [])

  return [settings, updateSetting, updateSettings]
}
